import { createSelector } from "reselect"
import lodash from "lodash"

export const makeSelectState = () => state => state.Addressbook
export const makeSelectAdd = () =>
  createSelector(makeSelectState(), state => state.add)
export const makeSelectAddIsLoading = () =>
  createSelector(makeSelectAdd(), state => state.isLoading)
export const makeSelectAddResult = () =>
  createSelector(makeSelectAdd(), state => state.result)
export const makeSelectAddError = () =>
  createSelector(makeSelectAdd(), state => state.error)
export const makeSelectItemsById = () =>
  createSelector(makeSelectState(), state => state.itemsById)
export const makeSelectItemsByIndex = () =>
  createSelector(makeSelectState(), state => state.itemsByIndex)
export const makeSelectLoadedPages = () =>
  createSelector(makeSelectState(), state => state.loadedPages)
export const makeSelectTotalCount = () =>
  createSelector(makeSelectState(), state => state.totalCount)
export const makeSelectUi = () =>
  createSelector(makeSelectState(), state => state.ui)
export const makeSelectIsLoading = () =>
  createSelector(makeSelectState(), state => state.isLoading)
export const makeSelectFilter = () =>
  createSelector(makeSelectState(), state => state.filter)
export const makeSelectFilterForm = () =>
  createSelector(makeSelectState(), state => state.filterForm)
export const makeSelectInitFilter = () =>
  createSelector(makeSelectState(), state => state.initFilter)
export const makeSelectCurrentFilter = () =>
  createSelector(makeSelectState(), state => state.currentFilter)
export const makeSelectItems = () =>
  createSelector(
    [makeSelectItemsById(), makeSelectItemsByIndex()],
    (itemsById, itemsByIndex) => {
      return lodash.mapValues(itemsByIndex, id => itemsById[id])
    }
  )

const noWildcardAllowed = [
  "country",
  "zip",
  "usePickupAddress",
  "useDeliveryAddress"
]

export const makeSelectFilterClean = () =>
  createSelector(makeSelectFilter(), (filter) =>
    lodash.pickBy(
      lodash.mapValues(
        filter,
        (value, key) => `${value}${noWildcardAllowed.includes(key) ? "" : "*"}`
      ),
      f => Boolean(f) && f !== ""
    )
  )
